export default {
    'Monday': 'Понедельник',
    'Tuesday': 'Вторник',
    'Wednesday': 'Среда',
    'Thursday': 'Четверг',
    'Friday': 'Пятница',
    'Saturday': 'Суббота',
    'Sunday': 'Воскресенье',

    'Mo': 'Пн',
    'Tu': 'Вт',
    'We': 'Ср',
    'Th': 'Чт',
    'Fr': 'Пт',
    'Sa': 'Сб',
    'Su': 'Вс', 

    'January': 'Январь',
    'February': 'Февраль',
    'March': 'Март',
    'April': 'Апрель',
    'May': 'Май',
    'June': 'Июнь',
    'July': 'Июль',
    'August': 'Август',
    'September': 'Сентябрь',
    'October': 'Октябрь',
    'November': 'Ноябрь',
    'December': 'Декабрь',

    'Jan': 'Янв',
    'Feb': 'Фев',
    'March': 'Март',
    'Apr': 'Апр',
    'May': 'Май',
    'June': 'Июнь',
    'July': 'Июль',
    'Aug': 'Авг',
    'Sept': 'Сен',
    'October': 'Окт',
    'Nov': 'Нояб',
    'Dec': 'Дек',
};
